// extracted by mini-css-extract-plugin
module.exports = {"section":"FAQLandownersPage_section__8ooDZ","sectionFullWidth":"FAQLandownersPage_sectionFullWidth__27W9P","sectionMarginless":"FAQLandownersPage_sectionMarginless__pm4x6"};